<template>
  <div class="learning-path-banner" :style="style">
    <div class="overlay"></div>
    <div class="content" :class="contentClass">
      <h2 class="font-weight-bold px-2 p-md-0">
        {{ learningPath.name }}
      </h2>
      <h4 class="px-2 p-md-0">{{ learningPath["length"] }}</h4>
      <div v-if="showEnrollButtons || $root.isPublicUser" class="buttons mt-4">
        <a
          v-if="canEnroll || $root.isPublicUser"
          class="btn btn-primary w-75 mb-3 w-sm-auto mb-sm-0 mr-sm-2"
          :href="route('enroll.online.learning-path.self', routeParam)"
          >Purchase Path for Self</a
        >
        <a
          v-if="canEnrollOthers"
          class="btn btn-primary w-75 w-sm-auto"
          :href="route('enroll.online.learning-path.others', routeParam)"
          >Purchase Path for Others</a
        >
      </div>
      <div v-else-if="preview" class="buttons mt-4">
        <a class="btn btn-primary w-75 mb-3 w-sm-auto mb-sm-0 mr-sm-2" href="#"
          >Purchase Path for Self</a
        >
        <a class="btn btn-primary w-75 w-sm-auto" href="#"
          >Purchase Path for Others</a
        >
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    learningPath: { type: Object, required: true },
    enrollment: { type: Object, default: () => {} },
    contentClass: { type: String },
    preview: { type: Boolean, default: false },
  },
  computed: {
    routeParam() {
      return { learning_path: this.learningPath.id };
    },
    style() {
      var style = "";
      if (!!this.learningPath.image_url) {
        style = `background-image: url('${this.learningPath.image_url}');`;
      }
      return style;
    },
    canEnroll() {
      return !!this.enrollment
        ? !!this.enrollment.can_enroll
        : !!this.learningPath.can_enroll;
    },
    canEnrollOthers() {
      return !!this.enrollment
        ? !!this.enrollment.can_enroll_others
        : !!this.learningPath.can_enroll_others;
    },
    showEnrollButtons() {
      return this.canEnroll || this.canEnrollOthers;
    },
  },
};
</script>